import React from "react";
import AttachmentPreviewSkeleton from "./PreviewSkeleton";

type VideoPreviewProps = {
  fileUrl?: string;
  fileName?: string;
  zoomLevel?: number;
};

const VideoPreview: React.FC<VideoPreviewProps> = ({
  fileUrl,
  fileName,
  zoomLevel = 100,
}) => {
  const [isReady, setIsReady] = React.useState(false);
  const [hasLoadError, setHasLoadError] = React.useState(false);

  React.useEffect(() => {
    setIsReady(false);
    setHasLoadError(false);
  }, [fileUrl]);

  if (!fileUrl) {
    return <AttachmentPreviewSkeleton zoomLevel={zoomLevel} />;
  }

  if (hasLoadError) {
    return <AttachmentPreviewSkeleton zoomLevel={zoomLevel} />;
  }

  const zoomScale = zoomLevel / 100;

  return (
    <main className="h-full min-h-0 w-full bg-gray-100 overflow-auto">
      <div className="relative flex min-h-full w-full items-center justify-center p-6 box-border">
        {!isReady ? (
          <div className="absolute inset-0 z-10 flex items-center justify-center bg-gray-100">
            <AttachmentPreviewSkeleton zoomLevel={zoomLevel} />
          </div>
        ) : null}
        <div
          className="flex justify-center"
          style={{ width: `${zoomLevel}%` }}
        >
          <video
            key={fileUrl}
            className="h-auto w-full object-contain"
            style={{
              maxHeight: `calc((100vh - 160px) * ${zoomScale})`,
            }}
            controls
            playsInline
            preload="metadata"
            aria-label={fileName || "Video attachment"}
            src={fileUrl}
            onLoadedData={() => setIsReady(true)}
            onError={() => {
              setHasLoadError(true);
              setIsReady(false);
            }}
          />
        </div>
      </div>
    </main>
  );
};

export default VideoPreview;
